import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const Users = () => import('./pages');

const moduleRoute = {
  path: 'company-settings/users',
  name: 'Users',
  component: Users,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.COMPANY_USERS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
